import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type SchoolRolloverService from 'teacher-ui-client/services/school-rollover'

export default class extends Route {
  @service session!: SessionService

  @service schoolRollover!: SchoolRolloverService

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const activeRolloverCount = this.schoolRollover.activeRollovers?.length ?? 0

    const isHomeschool = this.session.currentSchool?.isHomeschool

    return {
      subscriptionType,
      currentTeacher: this.session.currentTeacher,
      isSubco: this.session.currentTeacher.subcoFor(subscriptionType),
      isRolloverInProgress: activeRolloverCount > 0,
      isHomeschool,
    }
  }
}
